import { useState } from 'react';
import { sortBy } from 'lodash-es';
import { RadioButtonWithLabel, Typography, useOverlayContext } from 'seagull';
import { filterCustomerWorkspaces } from "../welcomeStepUtils";
import { ResponsiveModal } from "../../../components/ResponsiveModal";
import { useResponsive } from "../../../contexts";
import { sendErrReport } from "../../../../infra/utils";
import { selectors } from "../../../../store/state-selectors";
import { useStore, useStoreActions } from "../../../../store/store-context";
import styles from "./SwitchProposalBusiness.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SwitchProposalBusiness(props) {
  const {
    relationship,
    onClose
  } = props;
  const relationshipId = relationship.id;
  const {
    api,
    logBI
  } = useStoreActions();
  const email = useStore(state => {
    var _state$userInfo;
    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.email();
  });
  const worksAt = useStore(selectors.user.business);
  const workspaces = useStore(selectors.user.workspaces);
  const {
    isDesktop
  } = useResponsive();
  const overlayContext = useOverlayContext();
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
  const clientWorkspaces = sortBy(filterCustomerWorkspaces(workspaces !== null && workspaces !== void 0 ? workspaces : [], relationship.vendor.id), workspace => workspace.name());
  const onApproveBusinessChange = async () => {
    const shouldSwitchBusiness = selectedWorkspaceId && selectedWorkspaceId !== (worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    if (shouldSwitchBusiness) {
      logBI(10835, {
        companyName: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name,
        email
      });
      try {
        await api.relationship.associateCustomer(relationshipId, selectedWorkspaceId);
        onClose(selectedWorkspaceId);
      } catch (err) {
        sendErrReport(err);
        overlayContext.showErrorToast('Failed to assign a proposal to a different business', 'switch-business-failure-toast');
      }
    } else {
      onClose();
    }
  };
  return /*#__PURE__*/_jsxs(ResponsiveModal, {
    testId: "switch-proposal-business-modal",
    title: "Assign proposal to a different business",
    mobileTitle: "Assign proposal to a different business",
    onClose: function (_onClose) {
      function onClose() {
        return _onClose.apply(this, arguments);
      }
      onClose.toString = function () {
        return _onClose.toString();
      };
      return onClose;
    }(() => onClose()),
    isDesktop: isDesktop,
    primaryButtonLabel: "Assign proposal",
    onPrimaryButtonClick: onApproveBusinessChange,
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: () => onClose(),
    children: [/*#__PURE__*/_jsx(Typography, {
      as: "span",
      children: "This proposal is currently assigned to "
    }), /*#__PURE__*/_jsx(Typography, {
      weight: "bold",
      as: "span",
      testId: "current-company",
      children: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name
    }), /*#__PURE__*/_jsx(Typography, {
      as: "span",
      children: " and a new business will be created once this proposal is signed."
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Typography, {
      children: "If you believe this proposal is intended for an existing business, select the business to which this proposal should be assigned."
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: "Select business:"
    }), /*#__PURE__*/_jsx("div", {
      className: styles.businessOptionsWrapper,
      children: clientWorkspaces === null || clientWorkspaces === void 0 ? void 0 : clientWorkspaces.map(workspace => {
        return /*#__PURE__*/_jsx(RadioButtonWithLabel, {
          label: workspace.name(),
          testId: "business-option",
          checked: selectedWorkspaceId === workspace.id(),
          onChange: () => setSelectedWorkspaceId(workspace.id())
        }, workspace.id());
      })
    })]
  });
}